// extracted by mini-css-extract-plugin
export default {"container":"Info_container__pnbu9","flexContainer":"Info_flexContainer__-tvcq","title":"Info_title__80QFl","description":"Info_description__4BBAy"};